export const editorStyle = () => ({
  customColumnEditor: {
    marginTop: '0px !important',

    '& .custom-column-editor-area': {
      display: 'flex',
      height: 261,

      '& .editor-container': {
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #605E5C',
        marginRight: '7px',

        '&.error': {
          borderColor: '#A80000',
        },
        '& .expression-editor-controls': {
          backgroundColor: '#F3F2F1',
          marginBottom: 5,
          padding: 5,
          height: '48px',
          display: 'flex',

          '& button': {
            '& .iconba': {
              color: '#106EBE',
            },
          },
        },
        '& .expression-container': {
          width: '600px',
          cursor: 'text',
          flex: '1',
          mozAppearance: 'textfield',
          webkitAppearance: 'textfield',
          backgroundColor: '-moz-field',
          padding: '8px 3px',
          userSelect: 'none',
          overflowY: 'auto',

          '& .custom-column-expression-token': {
            display: 'inline-block',
            lineHeight: '24px',
            fontSize: '14px',

            '& .custom-column-selected-metric': {
              display: 'inline-block',
              height: 'auto',
              padding: '4px 8px 5px',
              minWidth: 'auto',
              fontSize: '12px',
              lineHeight: '12px',
              border: '0px',

              '& button': {
                background: 'none',
                border: 'none',
                padding: 0,
                minWidth: 'auto',
                height: 'auto',
                fontSize: '12px',
                zIndex: '10',

                '& .iconba': {
                  fontSize: '12px',
                },
              },
            },
          },
        },
      },
      '& .custom-column-segment-selector': {
        border: '1px solid #605E5C',
        padding: '8px',
        overflowY: 'auto',
        width: '300px',

        '& .segmentation-header': {
          fontWeight: 'bold',
          '& strong': {
            color: '#0078D4 !important',
          },
        },

        '& .checkbox': {
          margin: '0',
        },

        '& #custom-column-segment-selector-interactive-area': {
          '& .btn.btn-link': {
            color: '#0078D4',
            border: 'none',
            padding: '0px',

            '& .iconba': {
              marginLeft: '0px',
            },
          },
        },
      },
    },
  },
});
